<template>
  <div id="qq-map-container">
    <!--<template v-if="search">
      <el-autocomplete :fetch-suggestions="goSearch" placeholder="请输入查询地址" size="small"
                       class="TMap-input TMap-control"
                       @select="selectItem"
                       v-model="searchValue">
        <template slot-scope="{item}">
          <b>{{ item.title }}</b>
          <br/>
          <span class="autocomplete-address">{{ item.address }}</span>
        </template>
      </el-autocomplete>
    </template>-->
  </div>
</template>

<script>
  import qs from 'qs';
  import { isEmpty, everyNotEmpty } from '../plugins/utils';

  export default {
    name: "TxMap",
    props: {
      axis: {
        type: Object,
        default: () => {
          return {}
        }
      },
      search: {
        type: Boolean,
        default: true
      }
    },
    comments: {},
    data() {
      return {
        searchValue: '',
        lat: 27.994267,
        lng: 120.699366,
        map: null,
        markerLayer: null
      };
    },
    watch: {},
    async mounted() {
      if (!document.getElementById('TMapScript')) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://map.qq.com/api/gljs?v=1.exp&libraries=service&key=RXQBZ-EORKU-RTHV4-G4N3A-NGUB6-XXFMK`;
        script.id = 'TMapScript';
        script.onload = async ev => {
          await this.getMap();
        };
        document.body.appendChild(script);
      } else {
        await this.getMap();
      }
    },
    destroyed() {
      if (this.map && this.map.hasOwnProperty('destroy')) {
        this.map.destroy();
      }
    },
    methods: {
      async goSearch(search, cb) {
        if (isEmpty(search)) {
          cb([]);
          return;
        }
        let url = `/wapi/map/addrSearch?keyword=${search}&radius=1000&lat=${this.lat}&lng=${this.lng}`;
        this.axios.get(url).then(res => {
          if(res.success) {
            console.log(res)
            // const data = result?.data?.data;
            // cb(isEmpty(data) ? [] : data);
          }
        });
      },
      addr2latlng(address) {
        const params = {
          address
        }
        let url = `/wapi/map/addr2latlng?${qs.stringify(params)}`;
        this.axios.get(url).then(res => {
          if(res.success) {
            this.$emit('updateAddress', {location: { lat: res.data.lat, lng: res.data.lng }})
            const center = new TMap.LatLng(res.data.lat, res.data.lng)
            this.map.setCenter(center);
            this.markerLayer.remove(['only']);
            this.markerLayer.add({
              position: center,
              id: 'only'
            });
          }
        });
      },
      selectItem(item) {
        const { lat, lng } = item.location;
        let url = `/wapi/map/latlng2addr?lat=${lat}&lng=${lng}`;
        this.axios.get(url).then(res => {
          if(res.success) {
            console.log(res)
            // if (data && data.status === 0) {
            //   const { result } = data;
            //   if (result) {
            //     this.$emit('updateAddress', result);
            //   }
            // }
            this.map.setCenter(new TMap.LatLng(lat, lng));
            this.markerLayer.remove(['only']);
            this.markerLayer.add({
              position: new TMap.LatLng(lat, lng),
              id: 'only'
            });
          }
        });
      },
      async getMap() {
        let baseAxis = {
          lat: '30.28964254667502',
          lng: '120.07533779960795'
        };
        let makeMarkerFlag = false;
        if (this.axis && everyNotEmpty(this.axis.lat, this.axis.lng)) {
          baseAxis.lat = this.axis.lat;
          baseAxis.lng = this.axis.lng;
          makeMarkerFlag = true;
        }
        const center = new TMap.LatLng(baseAxis.lat, baseAxis.lng);
        this.map = await new TMap.Map('qq-map-container', {
          center: center,//设置地图中心点坐标
          zoom: 15,   //设置地图缩放级别
        });
        this.markerLayer = new TMap.MultiMarker({
          id: 'marker-layer',
          map: this.map
        });
        this.map.on('click', async (evt) => {
          const { lat, lng } = evt.latLng;
          let url = `/wapi/map/latlng2addr?lat=${lat}&lng=${lng}`;
          this.axios.get(url).then(res => {
            if(res.success) {
              this.$emit('updateAddress', {location: evt.latLng, data: res.data})
              this.markerLayer.remove(['only']);
              this.markerLayer.add({
                position: evt.latLng,
                id: 'only'
              });
            }
          });
        });
        if (makeMarkerFlag) {
          this.markerLayer.add({
            position: new TMap.LatLng(baseAxis.lat, baseAxis.lng),
            id: 'only'
          });
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  #qq-map-container {
    /*地图(容器)显示大小*/
    min-width: 340px;
    min-height: 60px;
  }

  /deep/ .el-autocomplete {
    position: absolute !important;
    left: 10px;
    top: 10px;
    z-index: 1001;
    width: 300px;

    .el-input__inner {
      border-color: var(--el-border-color-base) !important;
    }
  }

  .TMap-button {
    left: 315px;
  }

  .tmap-zoom-control .tmap-zoom-in {
    top: 0;
  }

  .autocomplete-address {
    font-size: 12px;
  }
</style>




// WEBPACK FOOTER //
// TxMap.vue?0df411e4